<template>

  <v-container fluid class="ma-0 pa-0" style="background:white;min-height:1000px">
    
    <v-row justify="center" class="mt-3">
      <v-col cols="11" xl="8" lg="8"  md="10" xs="11" sm="11">
        <label style="font-size:25px;color:#121212">{{BOARD_CONTENT.TITLE}}</label>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="11" xl="8" lg="8"  md="10" xs="11" sm="11" style="display:inline-flex">
        <v-icon size="50">
          mdi-account-circle
        </v-icon>
        <span class="ml-2">
          <div><label style="font-size:20px;color:#626262">관리자</label></div>
          <div><label style="font-size:16px;color:#626262">{{BOARD_CONTENT.UP_DATE}}</label></div>
        </span>
        <v-spacer/>
        <span class="ml-2">
          <v-btn @click="back" elevation="0" text >목록</v-btn>
        </span>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="11" xl="8" lg="8"  md="10" xs="11" sm="11">
        <div style="height:3px;background:#ececec"/>
      </v-col>
    </v-row>
      
    <!-- 
    <v-row align="start" justify="center">
      <v-col cols="11" xl="8" lg="8"  md="10" xs="11" sm="11">
        <div v-html="BOARD_CONTENT.DESC"/>
      </v-col>
    </v-row>
    -->

    <v-row align="start" justify="center">
      <v-col cols="11" xl="8" lg="8"  md="10" xs="11" sm="11">
        <viewer 
          v-if="BOARD_CONTENT.DESC != null" 
          :initialValue="BOARD_CONTENT.DESC" 
          @load="onEditorLoad"
          />
      </v-col>
    </v-row>

    <v-row style="height:200px"></v-row>

  </v-container>
</template>

<script>
import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import { Viewer } from '@toast-ui/vue-editor';
export default {

    components: {
      viewer: Viewer
    },

    data: () => ({

      show1: false,
      loading : false,    //로딩 표시
      progress_dialog:false,

      grade: 0,
      NOTICE_IDX:"",        //넘겨받은 게시글 번호
      BOARD_CONTENT:{},   //게시글 상세정보
      itemList: [],       //게시글 답글 댓글 리스트

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      dialog2:false,
      dialog_delete1: false,

      defaultItem: {
        NOTICE_IDX:null,
        LEVEL:1,
        STEP:1,
        COMMENT:'',
        NAME:'',
        PW:null
      },
      editedItem: {
      },

      numberrules:[v => Number.isInteger(Number(v)) || '숫자만 사용할 수 있습니다.'],

    }),


    beforeDestroy() {
    },

    mounted(){
      this.grade    = this.$session.get("GRADE");
      if(this.grade == undefined || this.grade == null){
        this.grade = 0;
      }
      this.NOTICE_IDX = this.$route.query.NOTICE_IDX;
      console.log("NOTICE IDX : " + this.NOTICE_IDX);
      this.loadpage();
    },

    create(){
      
    },

    methods: {

      onEditorLoad (v) {
        const el  = v.preview.el
        this.html = this.checkimg(el);
      },

      //이미지 무조건 100%로 표시
      checkimg(el){
        const len = el.firstChild.children
        for (const p of len) {
          for (const img of p.children) {
            if(img.src){
              img.style.width = "100%";
              ////console.log("img : " + img);
            } 
          }
        }
        return el.innerHTML   
      },

      movetop(){
        window.scrollTo(0,0);
      },

      back(){
        //뒤로
        this.$router.back();
      },
      
      loadpage(){

        //내용 가져오기
        this.loading = true;
        this.$http.post(this.$host+'/api/NoticeDetail',{
            NOTICE_IDX: this.NOTICE_IDX
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})        
        .then((result)=>{
          this.loading = false;
          if(result.data.resultCode == 0){
            //이미 선택된 아이템에 상세만 교체
            window.scrollTo(0,0);
            this.BOARD_CONTENT  = result.data.resultData[0];
            if(this.BOARD_CONTENT == undefined){
              this.$alert("게시글이 없습니다.");
            }
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
        });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage();
      },      

      //검색
      search_run(){
        this.loadpage();
      },
      

    },
  
}
</script>

<style lang="css">
  td{
    height: 36px !important;
  }
</style>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>
.v-main__wrap{
  background: white;
}
</style>